import React from "react";
import AdminPage from "../AdminPage";
import useAdminList from "../useAdminList";
import PartnersTable from "../PartnersListing/PartnersTable";

const COPY = {
  title: "Manage Partners",
  subtitle: "You Can See & Edit Detail About Partners",
  searchPlaceholder: "Search Here",
};

const PartnersAdmin = () => {
  const { items, loading, searchValue, setSearchValue } =
    useAdminList("getPartnersAdminPanel");

  return (
    <AdminPage
      title={COPY.title}
      subtitle={COPY.subtitle}
      loading={loading}
      search={{
        value: searchValue,
        onChange: setSearchValue,
        placeholder: COPY.searchPlaceholder,
      }}
    >
      <PartnersTable driverData={items} />
    </AdminPage>
  );
};

export default PartnersAdmin;
